import { communeParNom } from './communes-france.js';
import { isCountryCode } from './countries.js';
import { schoolZoneForDepartment } from './zones-france.js';
export function isValidCountryCode(value) {
    return isCountryCode(value);
}
/**
 * La zone de vacances scolaires d'une résidence, si elle peut se déduire.
 *
 * Aujourd'hui, seule la France a un calendrier scolaire couvert par le produit — les
 * autres pays n'ont pas de notion de zone A/B/C, et rendre `null` plutôt qu'une valeur
 * hasardeuse est le comportement correct, pas une lacune à combler ici. Un pays sans zone
 * dit simplement que la fonctionnalité s'arrête là pour l'instant.
 *
 * En France, la zone suit le département de la commune, pas un texte à interpréter : une
 * ville saisie hors de la liste connue (orthographe différente, commune trop petite pour
 * y figurer) rend `null` plutôt qu'une zone devinée au hasard.
 */
export function schoolZoneForResidence(residence) {
    if (residence.country !== 'FR')
        return null;
    const commune = communeParNom(residence.city);
    if (!commune)
        return null;
    return schoolZoneForDepartment(commune.departmentCode);
}
/**
 * Un pays de résidence par défaut, déduit du fuseau horaire du navigateur.
 *
 * Une détection franche demanderait la géolocalisation — une permission à accorder pour
 * gagner, au mieux, de pré-remplir un champ. Le fuseau, lui, est déjà connu sans rien
 * demander : `Europe/Paris` ne veut pas dire « en France » avec certitude (un expatrié
 * garde parfois l'heure de son pays d'origine), mais c'est vrai assez souvent pour qu'une
 * proposition par défaut vaille mieux qu'un champ vide — et elle reste à un geste de la
 * correction si elle se trompe.
 *
 * La liste ne couvre que les pays où Repère a des utilisateurs plausibles aujourd'hui
 * (France et ses voisins, voir `COUNTRIES_MIS_EN_AVANT`) : au-delà, mieux vaut ne rien
 * proposer que proposer au hasard un pays qu'aucun fuseau ne désigne sans ambiguïté.
 */
const PAYS_PAR_FUSEAU = {
    'Europe/Paris': 'FR',
    'Europe/Brussels': 'BE',
    'Europe/Zurich': 'CH',
    'Europe/Berlin': 'DE',
    'Europe/Busingen': 'DE',
    'Europe/Rome': 'IT',
    'Europe/Madrid': 'ES',
    'Africa/Ceuta': 'ES',
    'Atlantic/Canary': 'ES',
    'Europe/Luxembourg': 'LU',
    'Europe/Monaco': 'MC',
    'Europe/Andorra': 'AD',
    'Europe/London': 'GB',
};
/** Pays par défaut, à partir du fuseau du navigateur (`Intl`, ou celui fourni en test). */
export function defaultCountryFromTimeZone(timeZone) {
    const fuseau = timeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
    return PAYS_PAR_FUSEAU[fuseau] ?? 'FR';
}
//# sourceMappingURL=residence.js.map